import { defineStyleConfig } from '@chakra-ui/react';

const FormLabel = defineStyleConfig({
  baseStyle: {
    margin: '0',
    fontSize: '0.75rem',
    fontWeight: '700',
    lineHeight: 'normal',
    letterSpacing: '-0.214px',
  },
});

export default FormLabel;
